import axios from "axios";
import { PUBLIC_PATHS, UNAUTHORIZED } from "../store/Auth";
import AuthService from "./Auth/AuthService";

const ax = axios.create({
  baseURL: "/",
  withCredentials: true,
  timeout: 30000,
});

// Attach access token to every request
ax.interceptors.request.use(
  (config) => {
    const token = AuthService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.headers["Content-Type"]?.startsWith("multipart")) {
      config.timeout = 60000;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle 401 and force logout
ax.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === UNAUTHORIZED && !originalRequest._retry) {
      originalRequest._retry = true;
      AuthService.clearAccessToken();
      if (!PUBLIC_PATHS.includes(window.location.pathname)) {
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default ax;